import { Outlet } from "react-router-dom";
import { AccessGate } from "@/features/access/AccessGate";
import { DocumentTitle } from "./DocumentTitle";

/** Top-level route shell: sync the tab title, then render nested layouts. */
export function RootLayout() {
  return (
    <>
      <DocumentTitle />
      <AccessGate>
        <Outlet />
      </AccessGate>
    </>
  );
}
